import ReplyPills from './ReplyPills'

/* eslint-disable import/no-internal-modules */
import TopicPills from '../TopicInfo/TopicPills'

export interface PostMetadataProps {
  id?: string
  publicReplyId?: string
  publishedAt?: string
  spam: boolean
  pending: boolean
  trashed: boolean
  replyNumber?: number
  replyCount?: number
  pinned?: boolean
  isAuthor?: boolean
  isBestAnswer?: boolean
}

const PostMetadata = ({ id, publicReplyId, publishedAt, spam, pending, trashed, replyCount, replyNumber, pinned, isAuthor, isBestAnswer }: PostMetadataProps) => {
  return (
    <header className='clearfix'>
      <span className='text-muted post--time'>
        Posted on {publishedAt}
      </span>
      <div className='pull-right'>
        {replyNumber && replyCount
          ? <ReplyPills
              id={id}
              publicReplyId={publicReplyId}
              trashed={trashed}
              pending={pending}
              spam={spam}
              author={isAuthor}
              replyCount={replyCount}
              replyNumber={replyNumber}
              pinned={pinned}
              answer={isBestAnswer}
            />
          : <TopicPills author spam={spam} pending={pending} trashed={trashed} />}
      </div>
    </header>
  )
}

export default PostMetadata
